import React from 'react';
import { Image, Typography } from 'tfc-components';

import email from 'assets/icons/ic_email.svg';
import facebook from 'assets/icons/ic_facebook_contact.svg';
import linkedIn from 'assets/icons/ic_linkedIn_contact.svg';
import location from 'assets/icons/ic_location.svg';
import locationBanner from 'assets/images/contactUs/locaion-banner.png';
import Section from 'components/organisms/Section';

interface IContact {
  icon: string;
  key: string;
  value: string
}
/* Face Data */
const data: IContact[] = [
  { icon: location, key: 'Address', value: '1st Floor, 207 Nguyen Van Thu, Ward Da Kao, District 1, HCM' },
  { icon: email, key: 'Email', value: 'info@evollabs.vn' },
  { icon: facebook, key: 'Facebook', value: 'https://www.facebook.com/evollabs/' },
  { icon: linkedIn, key: 'LinkedIn', value: 'https://www.linkedin.com/company/evol-labs/' },
];
const Location:React.FC = () => (
  <Section className="p-contact_location">
    <div className="p-contact_location_inner">
      <div className="p-contact_location_left">
        <div className="p-contact_location_wrapTitle">
          <Section.Title className="p-contact_location_title">Our Location</Section.Title>
        </div>
        <Image extendClasses="p-contact_location_banner" imgSrc={locationBanner} alt="location banner" ratio={591 / 334} />
      </div>
      <div className="p-contact_location_content">
        {data.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="p-contact_location_item">
            <Image imgSrc={item.icon} ratio={1} alt="item-icon" extendClasses="p-contact_location_itemIcon" />
            <div className="p-contact_location_itemContent">
              <Typography.Text extendClasses="f-20x24 p-contact_location_itemTitle" fontweight="600">{item.key}</Typography.Text>
              <Typography.Text extendClasses="f-20x24 p-contact_location_itemValue">{item.value}</Typography.Text>
            </div>
          </div>
          ))}
      </div>
    </div>
  </Section>
  );

export default Location;
